import SafeDrivingIrrecoverableBottomSheetKr from '@di-shared/features/safe-driving/kr/SafeDrivingIrrecoverableBottomSheet.kr';
import React, {Suspense} from 'react';
import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';
import SafeDrivingIrrecoverableBottomSheetLoadingKr from '@di-shared/features/safe-driving/kr/SafeDrivingIrrecoverableBottomSheetLoading.kr';

const BOTTOM_SHEET_FALLBACK_HEIGHT = 350;

function SafeDrivingIrrecoverableBottomSheetPage() {
  const vin = (window as any).data.vin as string;

  return (
    <Suspense
      fallback={
        <BottomSheetWebViewWrapper bottomSheetFallbackHeight={BOTTOM_SHEET_FALLBACK_HEIGHT}>
          <SafeDrivingIrrecoverableBottomSheetLoadingKr />
        </BottomSheetWebViewWrapper>
      }
    >
      <BottomSheetWebViewWrapper bottomSheetFallbackHeight={BOTTOM_SHEET_FALLBACK_HEIGHT}>
        <SafeDrivingIrrecoverableBottomSheetKr vin={vin} />
      </BottomSheetWebViewWrapper>
    </Suspense>
  );
}

export default SafeDrivingIrrecoverableBottomSheetPage;
